import { apiRequest } from '../services/apiService';

export interface ExpenseReceipt {
  _id: string; chargeId?: string; sourceType?: 'reimbursement'; reimbursementId?: string; canRemove?: boolean; fileName: string; contentType: string;
  size: number; state: 'uploading' | 'ready' | 'failed'; uploadedAt: string | null;
}
export const RECEIPT_MAX_BYTES = 4 * 1024 * 1024;
export const RECEIPT_MAX_SELECTED = 20;
export const RECEIPT_MAX_SELECTED_BYTES = 6 * 1024 * 1024;
export const receiptError = (error: any) => {
  const message = error?.response?.data?.message || error?.message;
  return Array.isArray(message) ? message.join('. ') : message || 'Unable to access receipts. Please retry.';
};
export async function listExpenseReceipts(eventId: string, chargeId?: string, includeReimbursements = false): Promise<ExpenseReceipt[]> {
  const { response, error } = await apiRequest({ method: 'GET', url: 'billable-expense-receipts', isToken: true, params: { eventId, ...(chargeId ? { chargeId } : {}), ...(includeReimbursements ? { includeReimbursements: true } : {}) } });
  if (error || !response) throw error || new Error('Unable to load receipts');
  return Array.isArray(response.data?.data) ? response.data.data : [];
}
export async function uploadExpenseReceipt(eventId: string, chargeId: string, file: File, requestId: string) {
  const data = new FormData(); data.append('file', file); data.append('requestId', requestId);
  const { response, error } = await apiRequest({ method: 'POST', url: 'billable-expense-receipts', isToken: true, params: { eventId, chargeId }, data });
  if (error || !response) throw error || new Error('Unable to upload receipt');
  return response.data?.data as ExpenseReceipt;
}
export async function archiveExpenseReceipt(eventId: string, receiptId: string) {
  const { response, error } = await apiRequest({ method: 'DELETE', url: `billable-expense-receipts/${encodeURIComponent(receiptId)}`, isToken: true, params: { eventId } });
  if (error || !response) throw error || new Error('Unable to remove receipt');
}
export async function downloadExpenseReceipt(eventId: string, receipt: ExpenseReceipt) {
  const { response, error } = await apiRequest({ method: 'GET', url: `${receipt.sourceType === 'reimbursement' ? 'reimbursement-receipts' : 'billable-expense-receipts'}/${encodeURIComponent(receipt._id)}/file`, isToken: true, params: { eventId, ...(receipt.sourceType === 'reimbursement' ? { reimbursementId: receipt.reimbursementId } : {}) }, file: true });
  if (error || !response) throw error || new Error('Unable to download receipt');
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a'); link.href = url; link.download = receipt.fileName;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
